export const CARTA_TELEFONO = '(+34) 670 02 83 61';
export const CARTA_EMAIL = 'info@botomatic.es';
export const CARTA_WEB = 'www.botomatic.es';

export const PASOS_FIRMA = [
  { id: 'type', label: 'Tipo' },
  { id: 'profile', label: 'Datos' },
  { id: 'documents', label: 'Lectura' },
];

const TITULOS = {
  PERSONA_FISICA: 'Persona física',
  AUTONOMO: 'Autónomo',
  EMPRESA: 'Empresa',
};

const PIES = {
  PERSONA_FISICA: 'Firmarás un contrato y DPA combinados.',
  AUTONOMO: 'Firmarás el contrato y el DPA de autónomo.',
  EMPRESA: 'Firmarás el contrato y el DPA de empresa.',
};

export function etiquetaTipoCuenta(code) {
  if (!code) return '—';
  return TITULOS[code] || code;
}

export function pieTipoCuenta(code) {
  return PIES[code] || '';
}

export function mensajeContratoFirmado(emailSent) {
  return emailSent
    ? 'Contrato firmado correctamente'
    : 'Contrato firmado. No se pudo enviar el correo.';
}

export function parrafosDocumento(texto) {
  if (!texto || !String(texto).trim()) return [];
  return String(texto)
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);
}

export function etiquetaBotonCertificado(acceptance, documents) {
  const doc = (documents || []).find(
    (d) => Number(d.versionId) === Number(acceptance?.documentVersionId),
  );
  const nombre = acceptance?.documentTypeName || doc?.documentTypeName || '';
  if (/combinado/i.test(nombre) || /persona física/i.test(nombre)) {
    return 'Ver constancia del contrato y DPA';
  }
  if (/DPA/i.test(nombre)) {
    return 'Ver constancia del DPA';
  }
  if (nombre) return 'Ver constancia del contrato';
  return 'Ver constancia';
}
